import {HTTP} from "@/helpers/http-common"
import * as R from "ramda";

const get = (auditoria) =>new Promise((resolve,reject)=>{
  const {clave, tabla, descripcion, revision} = auditoria;
  HTTP
  .post(
    '/api/auditoria'
    , {clave, tabla, descripcion, revision:null}
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const details = (auditoria) =>new Promise((resolve,reject)=>{
  const {clave, tabla, descripcion, revision} = auditoria;
  HTTP
  .post(
    '/api/auditoria/details'
    , {clave, tabla, descripcion, revision}
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const reporte = (auditoria) =>new Promise((resolve,reject)=>{
  const {usuario, modulo, fecha} = auditoria;
  HTTP
  .post(
    '/api/auditoria/reporte'
    , {usuario, modulo, fecha}
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const reporteExcel = (auditoria) =>new Promise((resolve,reject)=>{
  const {usuario, modulo, fecha} = auditoria;
  HTTP
  .post(
    '/api/auditoria/reporteExcel'
    , {usuario, modulo, fecha}
    , {responseType: 'blob'}
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });

});


//Export methods
export default {
  get
  , details
  , reporte
  , reporteExcel
}





// WEBPACK FOOTER //
// ./src/services/bitacoras/auditoria/index.js